import ReportIdLinkView from "./ReportIdLinkView.js";
import ReportScheduleDialog from "../ReportScheduleDialog";
import ReportDialog from "../ReportDialog";

export const REPORT_COLUMNS = function (bindFunctions) {
    return [
    // {
    //     field: "id",
    //     headerName: "id",
    //     flex: 1,
    //     minWidth: 150,
    //     // renderCell: (params) => {            
    //     //     return <ReportIdLinkView id={params.value} />
    //     // },
    //     renderCell: (params) => params.value?.name,
    // },
     
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return (
          <ReportDialog
            reportId={params.row.id}
            selectedReportName={params.value}
            fetchReports={bindFunctions.fetchReports}
            componentPermissions={bindFunctions.componentPermissions}
            actionType={bindFunctions.actionType}
          />
        );
      },
    },

    // {
    //     field: "name",
    //     headerName: "Name",
    //     flex: 1,
    //     minWidth: 150,
    //     renderCell: (params) => {            
    //         return <ReportIdLinkView editReportId={params.row.id} selectedReport={params.value.name} />
    //     },
    //     renderCell: (params) => params.value?.name,
    // },
    {
        field: "organizationName",
        headerName: "Organization",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name,

    },

    {
        field: "requestTypeName",
        headerName: "Request Type",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name,

    },

    {
        field: "priorityName",
        headerName: "Priority",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name,

    },
    {
        field: "assetItemName",
        headerName: "Asset Item",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name,

    },
    {
        field: "resolverGroupName",
        headerName: "Resolver Group",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name,

    },
    {
        field: "resolverUserName",
        headerName: "Resolver",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name,

    },
    {
        field: "active",
        headerName: "Active",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name,

    },   
    {
        //field: "id",
        headerName: "Schedule",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => (
              <ReportScheduleDialog
                editReportId={params.row.id}
                selectedReport={params.row.name}
              />
            )

    },     
]
};